import { useCallback } from 'react'
import { type TranslationValues, useTranslation } from 'i18nano'
import type {
	TranslationKeys,
	TranslationPaths,
	TranslationPathValue,
	TranslationPrefixes,
} from 'shared/lib/i18n'

export type TranslationFunction<P extends TranslationPrefixes | undefined> = (
	path: P extends TranslationPrefixes
		? Extract<keyof TranslationPathValue<TranslationKeys, P>, string>
		: TranslationPaths,
	values?: TranslationValues,
) => string
export type ColumnTranslationFunction = (
	path: string, //keyof TranslationKeys['columns' ]  TODO: fix
	values?: TranslationValues,
) => string

type Translate<P extends TranslationPrefixes | undefined> = {
	t: TranslationFunction<undefined>
	prefixT: TranslationFunction<P>
}

export const useTranslate = <P extends TranslationPrefixes | undefined>(
	prefix?: P,
): Translate<P> => {
	const translation = useTranslation()

	const t = useCallback<TranslationFunction<undefined>>(
		(path, values) => translation(path, values),
		[translation],
	)

	const prefixT = useCallback<TranslationFunction<P>>(
		(path, values) =>
			translation(`${prefix ? `${prefix}.` : ''}${String(path)}`, values),
		[translation, prefix],
	)

	return { t, prefixT }
}
